var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-v-8fc42042": "",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    style: {
      width: 22,
      height: 22
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i-15187692__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 .823a11.177 11.177 0 1 0 0 22.353A11.177 11.177 0 0 0 12 .823Zm8.538 7.451c.498 1.14.777 2.4.777 3.726a9.283 9.283 0 0 1-.777 3.726h-4.2c.205-1.156.317-2.412.317-3.726s-.112-2.57-.317-3.726h4.2ZM9.208 12c0-1.338.102-2.604.289-3.726H14.5c.187 1.122.292 2.388.292 3.726s-.105 2.604-.292 3.726h-5A22.938 22.938 0 0 1 9.207 12Zm10.244-5.589h-3.547c-.433-1.454-1.027-2.65-1.727-3.468a9.32 9.32 0 0 1 5.274 3.468ZM12 3.62c.827 0 1.572 1.08 2.083 2.794H9.917C10.428 4.698 11.173 3.62 12 3.62Zm-2.178-.674c-.7.816-1.294 2.016-1.725 3.468H4.55a9.32 9.32 0 0 1 5.272-3.468Zm-6.36 5.33h4.2A21.398 21.398 0 0 0 7.345 12c0 1.314.112 2.57.317 3.726h-4.2A9.281 9.281 0 0 1 2.685 12c0-1.325.278-2.585.777-3.726Zm1.086 9.314h3.547c.433 1.454 1.027 2.65 1.727 3.468a9.32 9.32 0 0 1-5.274-3.468ZM12 20.38c-.827 0-1.572-1.08-2.083-2.794h4.166c-.515 1.715-1.256 2.794-2.083 2.794Zm2.178.674c.7-.815 1.294-2.016 1.725-3.468h3.547a9.32 9.32 0 0 1-5.272 3.468Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i-15187692__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.8.8h22.4v22.4H.8z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.8da4cbf49f07685c979daae75c561c4f.svg";
export { ForwardRef as ReactComponent };